import { SurveySchemaReferenceUrl } from '../../../models/graphqlTypes'

export function isValidHttpUrl(urlToCheck: string): boolean {
  let url

  try {
    url = new URL(urlToCheck)
  } catch (error) {
    console.warn(error)
    return false
  }

  return url.protocol === 'http:' || url.protocol === 'https:'
}

export function getNumberOfReferences(
  url: string | null | SurveySchemaReferenceUrl[] | undefined
): string {
  let arrayLength = 0
  if (Array.isArray(url)) {
    arrayLength = url.length
  } else if (!!url && url?.includes('[')) {
    arrayLength = JSON.parse(url).length
  }
  return !!arrayLength ? ` (${arrayLength})` : ''
}
